module.exports = __webpack_public_path__ + "img/base_activites_moto.ee220ead.svg";